module.exports = __webpack_public_path__ + "img/ali_pay_btn.712c0a75.png";